<template>
  <div class="mt-2 bg-white">
    <div v-if="propertyDetails && propertyDetails.length"
      ><div v-for="(item, i) in propertyObject" :key="i">
        <div class="border baseContentFont px-3 py-2">
          <div>
            <div v-if="item.nodForeclosureProperty === null">
              <div class="d-flex justify-content-between">
                <div>
                  <div
                    ><strong>{{
                      formatDisplay(item.streetAddress)
                    }}</strong></div
                  >
                  <div
                    ><strong>{{ formatDisplay(item.cityCode) }}</strong></div
                  >
                </div>
                <div>
                  <div
                    ><strong>County</strong>:
                    {{ formatDisplay(item.county) }}</div
                  >
                  <div><strong>APN</strong>: {{ formatDisplay(item.apn) }}</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="d-flex justify-content-between">
                <div>
                  <div
                    ><strong>{{
                      formatDisplay(item.nodForeclosureProperty.streetAddress)
                    }}</strong></div
                  >
                  <div
                    ><strong>{{
                      formatDisplay(item.nodForeclosureProperty.cityCode)
                    }}</strong></div
                  >
                </div>
                <div>
                  <div
                    ><strong>County</strong>:
                    {{ formatDisplay(item.nodForeclosureProperty.county) }}</div
                  >
                  <div
                    ><strong>APN</strong>:
                    {{ formatDisplay(item.nodForeclosureProperty.apn) }}</div
                  >
                </div>
              </div>
            </div>
            <div class="pt-1">
              <BaseELabel label="Record Details" class="mb-2" new-style />
              <b-table
                :items="item.recordDetails"
                :fields="orderFields"
                bordered
                responsive
                striped
                class="mb-0 fraudReportHeaderTable"
              >
                <template v-slot:head(Recording_Date)="data">
                  <div class="text-right">{{ data.label }}</div>
                </template>
                <template v-slot:cell(Recording_Date)="data">
                  <div class="text-right">{{ data.item.Recording_Date }}</div>
                </template>
                <template v-slot:head(Case_Number)="data">
                  <div>{{ data.label }}</div>
                </template>
                <template v-slot:cell(Case_Number)="data">
                  <div>{{ data.item.Case_Number }}</div>
                </template>
                <template v-slot:cell(Type)="data">
                  {{ data.item.Record_Type }}
                </template>
                <!-- showing customised label -->
                <template v-slot:head(Loan_Default_Date)="data">
                  <div class="text-right">{{ data.label }}</div>
                </template>
                <!-- showing value for the key Loan_Default_Date -->
                <template v-slot:cell(Loan_Default_Date)="data">
                  <div class="text-right">{{
                    data.item.Date_of_Loan_Default
                  }}</div>
                </template>
                <template v-slot:cell(Loan_Default_Amount)="data">
                  {{ data.item.Amount_of_Loan_Default }}
                </template>
              </b-table>
              <NoRecordFound v-if="!item.recordDetails.length"></NoRecordFound>
            </div>
          </div>
          <b-row class="pl-3 mt-2">
            <div><BaseELabel label="Property Details " class="mb-2" new-style /> </div>
            <div v-if="item.nodForeclosureProperty !== null" class="ml-1"
              ><BaseELabel
                :label="
                  ` (${formatDisplay(
                    item.nodForeclosureProperty.recordingDate
                  )})`
                "
                class="mb-2" new-style /></div
          ></b-row>
          <div v-if="item.nodForeclosureProperty !== null">
            <div :class="$style.propertyDetails" class="border px-3 py-1">
              <b-row>
                <b-col
                  ><strong>Seller</strong>:
                  {{ formatDisplay(item.seller) }}
                </b-col>
                <b-col
                  ><strong>Loan Type</strong>:
                  {{
                    formatDisplay(item.nodForeclosureProperty.loanType)
                  }}</b-col
                >
                <b-col
                  ><strong>Loan Amount</strong>:
                  {{
                    formatDisplay(item.nodForeclosureProperty.loanAmount)
                  }}</b-col
                >
              </b-row>
              <b-row>
                <b-col
                  ><strong>Buyer</strong>:
                  {{ formatDisplay(item.buyer) }}</b-col
                >
                <b-col
                  ><strong>Lender</strong>:
                  {{ formatDisplay(item.lenderandCompany) }}</b-col
                >
                <b-col
                  ><strong>Land Usage</strong>:
                  {{
                    formatDisplay(item.nodForeclosureProperty.landUse)
                  }}</b-col
                >
              </b-row>
            </div>
          </div>
          <NoRecordFound v-else></NoRecordFound>
          <!-- <div
            v-else
            :class="$style.propertyDetails"
            class="border p-3 text-center"
            ><strong></strong
          ></div> -->
        </div>
      </div>
    </div>
    <NoRecordFound v-else></NoRecordFound>
  </div>
</template>
<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    propertyData: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      propertyObject: [],
      orderDataItems: [],
      orderFields: [
        'Recording_Date',
        'Case_Number',
        'Type',
        'Document_Type',
        'Loan_Default_Date',
        'Loan_Default_Amount',
      ],
      orderItems: [],
      fID: '',
    }
  },
  computed: {
    propertyDetails() {
      return this.propertyData.nodforeclosure
    },
  },
  mounted() {
    if (this.propertyDetails && this.propertyDetails.length) {
      var resultsTable = []
      var nodPropData
      var streetAddress
      var cityCode
      let seller, buyer, lenderandCompany

      this.propertyDetails.forEach((x, index) => {
        let id = x.foreclosureUniqueId
        let foreclosureData = this.propertyDetails.filter(
          (i) => i.foreclosureUniqueId === id
        )
        if (this.fID !== x.foreclosureUniqueId) {
          this.fID = x.foreclosureUniqueId
          foreclosureData.forEach((item) => {
            if (item.recordingDate !== null && item.recordingDate !== '') {
              item.recordingDate = this.formatDate(item.recordingDate)
            }
            resultsTable.push({
              Recording_Date: this.formatDisplay(item.recordingDate),
              Record_Type: this.formatDisplay(item.recordType),
              Buyer: this.formatDisplay(item.buyer),
              Seller: this.formatDisplay(item.seller),
              Amount_of_Loan_Default: this.formatDisplay(item.amountOfDefault),
              Date_of_Loan_Default: this.formatDate(
                this.formatDisplay(item.dateOfLoan)
              ),
              Document_Type: this.formatDisplay(item.documentype),
              Lender: this.formatDisplay(item.lender),
              Case_Number: this.formatDisplay(item.caseNumber),
            })
            if (item.nodForeclosureProperty !== null) {
              item.nodForeclosureProperty.recordingDate = this.formatDate(
                item.nodForeclosureProperty.recordingDate
              )
              nodPropData = item.nodForeclosureProperty
            } else {
              streetAddress = item.streetAddress ? item.streetAddress : null
              cityCode = item.cityCode ? item.cityCode : null
            }
            buyer = item.buyer
            seller = item.seller
            lenderandCompany = this.lenderCompanyFn(
              item.nodForeclosureProperty.lender,
              item.companyName
            )
          })
          this.propertyObject.push({
            recordDetails: resultsTable,
            nodForeclosureProperty: nodPropData || null,
            streetAddress: streetAddress,
            cityCode: cityCode,
            buyer: buyer,
            seller: seller,
            lenderandCompany: lenderandCompany,
          })
          resultsTable = []
          streetAddress = null
          cityCode = null
        }
      })
    }
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
    formatDate(date) {
      if (date === null || date === '') {
        return ''
      }
      let d = new Date(date)
      return (
        (d.getMonth() + 1).toString().padStart(2, '0') +
        '/' +
        d
          .getDate()
          .toString()
          .padStart(2, '0') +
        '/' +
        d.getFullYear()
      )
    },
    lenderCompanyFn(name, companyName) {
      if (name && companyName) {
        return `${name}; ${companyName}`
      } else if (name) {
        return name
      } else {
        return companyName
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.propertyDetails {
  font-size: 13px;
}
</style>
